import { combineReducers } from '@reduxjs/toolkit';
import userReducer from '../../services/user';

export const rootReducer = combineReducers({ user: userReducer });

export type RootReducer = ReturnType<typeof rootReducer>;
